module.exports = __webpack_public_path__ + "img/ANTENNA PALMA GREEN.12103ca.svg";